import moment from "moment-timezone";

const TIMEZONE = "Europe/Paris";

const isoDate = (date, h, m, s = 0) => {
    // Always use Europe/Paris timezone for consistent date calculations
    const n = date
        ? moment.tz(date, TIMEZONE)
        : moment.tz(TIMEZONE);

    n.set({ hour: h, minute: m, second: s, millisecond: 0 });
    const isoString = n.toISOString();

    return isoString;
};

export default isoDate;